// extracted by mini-css-extract-plugin
export default {"team-item":"menu-item_team-item__geHXM","team-item--selected":"menu-item_team-item--selected__qOMwK"};